<template>
  <v-app-bar app color="primary" dark>
    <v-toolbar-title class="title">Axia Monitoring</v-toolbar-title>
    <v-spacer></v-spacer>
    <!-- Enlaces de navegación para pantallas grandes -->
    <v-toolbar-items
      class="d-none d-lg-flex"
      v-if="authStore.user?.empresa !== 4"
    >
      <v-btn text to="/"><v-icon left>mdi-map-marker</v-icon>Mapa</v-btn>
      <v-btn text to="/poc-status"
        ><v-icon left>mdi-list-status</v-icon>Inventario</v-btn
      >
      <v-btn text to="/NewData"
        ><v-icon left>mdi-table-large</v-icon>Eventos</v-btn
      >
      <v-btn text to="/incidencias"
        ><v-icon left>mdi-alert-circle</v-icon>Incidencias</v-btn
      >
      <v-btn text to="/graphics"
        ><v-icon left>mdi-chart-box</v-icon>Gráficos</v-btn
      >
      <!--
      <v-btn text to="/special"
        ><v-icon left>mdi-map-search</v-icon>Planos</v-btn
      >
      -->
      <v-menu offset-y>
        <template #activator="{ props }">
          <v-btn text v-bind="props">
            <v-icon left>mdi-folder</v-icon>Datos antiguos
          </v-btn>
        </template>
        <v-list>
          <v-list-item to="/inventory">
            <v-list-item-icon><v-icon>mdi-database</v-icon></v-list-item-icon>
            <v-list-item-title>Inventario antiguos</v-list-item-title>
          </v-list-item>
          <v-list-item to="/status">
            <v-list-item-icon
              ><v-icon>mdi-database-marker</v-icon></v-list-item-icon
            >
            <v-list-item-title>Estados</v-list-item-title>
          </v-list-item>
          <v-list-item to="/Logistics">
            <v-list-item-icon><v-icon>mdi-table</v-icon></v-list-item-icon>
            <v-list-item-title>Tabla MF</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar-items>
    <!-- Menú desplegable para pantallas pequeñas -->
    <v-menu
      offset-y
      class="d-lg-none"
      v-if="![4, 5, 6].includes(authStore.user?.empresa)"
    >
      <template #activator="{ props }">
        <v-btn icon v-bind="props" class="d-lg-none">
          <v-icon>mdi-menu</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item to="/">
          <v-list-item-icon><v-icon>mdi-map-marker</v-icon></v-list-item-icon>
          <v-list-item-title>Mapa</v-list-item-title>
        </v-list-item>
        <v-list-item to="/NewData">
          <v-list-item-icon><v-icon>mdi-table-large</v-icon></v-list-item-icon>
          <v-list-item-title>Eventos</v-list-item-title>
        </v-list-item>
        <v-list-item to="/poc-status">
          <v-list-item-icon><v-icon>mdi-list-status</v-icon></v-list-item-icon>
          <v-list-item-title>Inventario</v-list-item-title>
        </v-list-item>
        <v-list-item to="/incidencias">
          <v-list-item-icon><v-icon>mdi-alert-circle</v-icon></v-list-item-icon>
          <v-list-item-title>Incidencias</v-list-item-title>
        </v-list-item>
        <v-list-item to="/graphics">
          <v-list-item-icon><v-icon>mdi-chart-box</v-icon></v-list-item-icon>
          <v-list-item-title>Gráficos</v-list-item-title>
        </v-list-item>
        <!--
        <v-list-item to="/special">
          <v-list-item-icon><v-icon>mdi-map-search</v-icon></v-list-item-icon>
          <v-list-item-title>Planos</v-list-item-title>
        </v-list-item>
        -->
        <v-list-group
          v-model="menuAntiguo"
          prepend-icon="mdi-folder"
          no-action
          class="pl-2"
        >
          <template #activator="{ props }">
            <v-list-item v-bind="props" title="Datos antiguos" />
          </template>

          <v-list-item to="/inventory">
            <v-list-item-icon><v-icon>mdi-database</v-icon></v-list-item-icon>
            <v-list-item-title>Inventario antiguos</v-list-item-title>
          </v-list-item>
          <v-list-item to="/status">
            <v-list-item-icon
              ><v-icon>mdi-database-marker</v-icon></v-list-item-icon
            >
            <v-list-item-title>Estados</v-list-item-title>
          </v-list-item>
          <v-list-item to="/Logistics">
            <v-list-item-icon><v-icon>mdi-table</v-icon></v-list-item-icon>
            <v-list-item-title>Tabla MF</v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-menu>
    <!-- Menú del usuario -->
    <v-menu v-if="authStore.isAuthenticated" offset-y>
      <template #activator="{ props }">
        <v-btn text v-bind="props" class="d-flex align-center">
          <v-avatar size="36" v-if="authStore.user.photo">
            <v-img :src="authStore.user.photo" alt="Foto de perfil" />
          </v-avatar>
          <template v-else>
            <v-icon>mdi-account-circle</v-icon>
          </template>
          <span class="ml-2">{{ authStore.user.name || "Usuario" }}</span>
          <v-icon>mdi-chevron-down</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>{{
              authStore.user.name || "Usuario"
            }}</v-list-item-title>
            <v-list-item-subtitle>Bienvenido/a</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item
          v-if="![4, 5, 6].includes(authStore.user?.empresa)"
          @click="navigate('/Manuales')"
        >
          <v-list-item-title>
            <v-icon left>mdi-book-open-page-variant</v-icon>Manuales
          </v-list-item-title>
        </v-list-item>
        <v-list-item @click="navigate('/perfil')">
          <v-list-item-title>
            <v-icon left>mdi-account-edit</v-icon>Perfil
          </v-list-item-title>
        </v-list-item>
        <v-list-item v-if="isAdmin" @click="navigate('/admin/usuarios')">
          <v-list-item-title>
            <v-icon left>mdi-account-edit</v-icon>Usuarios
          </v-list-item-title>
        </v-list-item>
        <v-list-item @click="handleLogout">
          <v-list-item-title>
            <v-icon left>mdi-logout</v-icon>Logout
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
import { useAuthStore } from "@/stores/authStore";
import api from "@/services/api";
import router from "@/router";
import { ref, onMounted } from "vue";

export default {
  name: "NavBar",
  setup() {
    const authStore = useAuthStore();
    const menuAntiguo = ref(false);
    const { checkAdminStatus } = api;
    const isAdmin = ref(false);

    async function checkAdmin() {
      try {
        isAdmin.value = await checkAdminStatus();
      } catch (error) {
        console.error("Error checking admin status:", error);
      }
    }
    onMounted(async () => {
      await checkAdmin();
    });

    const handleLogout = () => {
      authStore.logout();
      router.push({ name: "Login" });
    };

    const navigate = (route) => {
      router.push(route);
    };

    return {
      authStore,
      handleLogout,
      navigate,
      menuAntiguo,
      isAdmin,
    };
  },
};
</script>

<style scoped>
.title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}
.d-lg-none {
  display: none;
}
@media (max-width: 1280px) {
  .d-lg-none {
    display: inline-flex;
  }
  .d-lg-flex {
    display: none;
  }
}
</style>
